export const Constants = {
	MESSAGE_URL: `/api/v1/messages`,
};
